module.exports = __webpack_public_path__ + "img/A低通锐化3.6ae58ab8.png";